import axios from 'axios';

const HTTP = axios.create({
  baseURL: process.env.VUE_APP_URL_API,
  timeout: process.env.VUE_URL_TIMEOUT,
  validateStatus: function (status) {
    return status >= 200 && status < 600; // default
  }
});

export default HTTP
